export default "__VITE_ASSET__2b76ee1b__"